<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_v"></a><a id="dedication"></a>To Andrea<br/>With love<br/>—ADM</p>
<p class="center">To Lawrence E. Glick and Nancy S. Glick<br/>With appreciation and thanks!<br/>—JDS</p>
<p class="center"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2b252e27